import type { QuoteDocument } from 'paintscout'

/**
 * Checks the given area keys to see if any of their substrates are part of a group in the quote
 */
export function hasGroupedSubstrates({ quote, keys }: { quote: QuoteDocument; keys: string[] }) {
  let isSplit = false
  const substrateChildren = quote.groups
    ? Object.values(quote.groups).reduce((all, group) => [...all, ...(group?.substrateChildren ?? [])], [] as string[])
    : []
  keys.forEach((key) => {
    if (isSplit) {
      return
    }
    const area = Object.values(quote?.areas ?? {}).find((a) => a.key === key)
    if (area) {
      const substrateKeys = area.substrateOrder.map((s) => s.key)
      if (substrateKeys.some((s) => substrateChildren.includes(s))) {
        isSplit = true
      }
    }
  })

  return isSplit
}
